import { MdlDialogReference, MdlDialogService } from '@angular-mdl/core';
import { UploadDialogBase } from '../base/upload-dialog-base';
import { UploadStorage } from '../../storages/upload-storage';
import { MethodUploadOptions } from '../base/method-upload-options';
import { FileToLanguage } from '../../../../covance-file-upload/covance-file-upload.component';
import { CultureInfo } from '../../../../core/culture-info';
import { FileFormArray } from '../../../../covance-file-upload/file-form-array';
import { CategoryNaturalKey } from '../../../../documents';
import { UploadedDocumentsStorage } from '../../storages/uploaded-documents-storage';

export abstract class SiteSpecificUploadDialogBase extends UploadDialogBase {
    public fileFormArray: FileFormArray;
    protected selectedFiles: FileToLanguage;

    protected constructor(
        protected readonly dialog: MdlDialogReference,
        protected readonly dialogService: MdlDialogService,
        private readonly uploadedDocumentsStorage: UploadedDocumentsStorage,
        uploadStorage: UploadStorage
    ) { 
        super(uploadStorage, dialog);

        this.fileFormArray = new FileFormArray();
        this.editorForm.addControl('files', this.fileFormArray);
    }  

    public resetFilesControl() {
        this.selectedFiles = null;
        this.editorForm.removeControl('files');
        this.fileFormArray = new FileFormArray();
        this.editorForm.addControl('files', this.fileFormArray);
    }

    public onFilesChanged(selectedFiles: Map<File, CultureInfo>) {
        this.selectedFiles = selectedFiles;
    }

    public async addFiles(message: string, categoryId: CategoryNaturalKey, documentMetadata: { [metadataName: string]: any }) {
        const confirmed = await this.showConfirm(message);

        if (confirmed) {
            this.upload(new MethodUploadOptions(
                categoryId,
                this.selectedFiles,
                documentMetadata,
                () => this.uploadedDocumentsStorage.forceLoadDocuments()
            ));
        }
    }

    protected async showConfirm(confirmationMarkup: string): Promise<boolean> {
        this.confirmationDialogOpened = true;

        try {
            await this.dialogService.confirm(confirmationMarkup as any, 'No', 'Yes').toPromise();
            return true;
        } catch {
            return false;
        } finally {
            this.confirmationDialogOpened = false;
        }
    }
}